<script lang="ts" setup>
import { GpTag } from '@gportal/uikit';
import { type Incident } from '@panel/plugins/types';
import ExternalLink from 'gpcore-uikit/components/Component.ExternalLink.vue';

defineProps<{
  incident: Incident;
}>();

const convertDate = (date: string) => {
  const dateObj = new Date(date);
  return dateObj.toLocaleString('default', {
    hour12: false,
    timeStyle: 'short',
    dateStyle: 'short',
  });
};
</script>

<template>
  <div>
    <template v-if="incident != null">
      <h4 class="tw-mb-4 tw-flex tw-items-center">
        <GpTag
          :label="incident.status.toUpperCase().replace('_', ' ')"
          size="xs"
          class="tw-mr-2 tw-block"
        />
        {{ incident.name }}
      </h4>
      <p class="tw-mb-4">
        Last updated at <strong>{{ convertDate(incident.updated_at) }}</strong
        >.
      </p>
      <ExternalLink
        :url="incident.shortlink"
        class="tw-text-black tw-underline hover:tw-text-black"
      >
        Click here for more information
      </ExternalLink>
    </template>
  </div>
</template>

<style scoped></style>
